<h1 mat-dialog-title>Print Settings</h1>
<div mat-dialog-content>
  <form class="standard-form">
    <mat-form-field>
      <mat-label>File Type</mat-label>
      <mat-select name="results.fileType" [(ngModel)]="results.fileType">
        <mat-option [value]="0">PDF</mat-option>
        <mat-option [value]="1">PPTX</mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container>
      <mat-label>Pages To Print</mat-label>
      <mat-selection-list #selectionList (selectionChange)="onSelectionChange($event)">
        <mat-list-option *ngFor="let page of data.pages" [value]="page" [selected]="isOptionSelected(page)">
          {{page.displayName}}
        </mat-list-option>
      </mat-selection-list>
    </ng-container>
  </form>

</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onPrintPreview()">View & Modify Pages</button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>
</div>
